import { Injectable } from '@angular/core';

@Injectable()
export class LayoutService {
	readonly singleItemRowSize = 2;
	readonly defaultRowSize = 3;
	readonly defaultShade = 45;

	private readonly baseLayouts: Record<number, number[][]> = {
		1: [[45]],
		2: [[45, 65]],
		3: [[45, 60, 70]],
		4: [
			[45, 60],
			[50, 65]
		],
		5: [
			[45, 60, 70],
			[50, 65]
		],
		6: [
			[45, 60, 70],
			[50, 65, 75]
		],
		7: [
			[45, 60, 70],
			[50, 65, 70, 80]
		],
		8: [
			[45, 60, 70, 75],
			[50, 65, 70, 80]
		]
	};

	getTileShade(total: number, index: number): number  | undefined{
		if (index < 0 || index >= total) {
			return this.defaultShade;
		}

		const layout = this.getLayout(total);

		if (!layout) {
			return this.defaultShade;
		}

		const pos = this.getRowAndColFromIndex(layout, index);

		return pos ? layout[pos.row][pos.col] : this.defaultShade;
	}

	getTileRowSize(total: number, index: number): number {
		if (total === 1) {
			return this.singleItemRowSize;
		}

		if (index < 0 || index >= total) {
			return this.defaultRowSize;
		}

		const layout = this.getLayout(total);

		if (!layout) {
			return this.defaultRowSize;
		}

		const pos = this.getRowAndColFromIndex(layout, index);

		return pos ? layout[pos.row].length : this.defaultRowSize;
	}

	private getLayout(total: number): number[][] | undefined {
		if (total <= 0) {
			return undefined;
		}

		return this.baseLayouts[total];
	}

	private getRowAndColFromIndex(layout: number[][], index: number): { row: number; col: number } | undefined {
		let remaining = index;

		for (let row = 0; row < layout.length; row++) {
			if (remaining < layout[row].length) {
				return { row, col: remaining };
			}
			remaining -= layout[row].length;
		}

		return undefined;
	}
}
